
import { framework_tool, utils_tool } from '../../tool'
let { requestUrl,ossFileUtils } = framework_tool;
let { Session } = utils_tool
export default {
  namespace: 'systemMenu',

  state: {
    menu: [],
    flatMenu: [],
  },

  /**
   * 监听当前路由
   */
  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((params) => {
        Session.set(constants.env.app_storage_key + '@nowPath', params['pathname'])
      });
    }
  },

  effects: {
    *getMenu({ payload }, { call, put }) {
      const { success, data, msg } = yield call(requestUrl.get, constants.urls.kUrlMenu, payload);
      let toSessionMenus = [];
      let f = (data) => {
        let _v = [];
        if (data) {
          data.forEach(val => {
            let v = {
              name: val['name'],
              path: val['url'],
              icon: val['icon'] ? ossFileUtils.getOssImgResizeUrl(val.fileUri, { m: 'fixed', w: 15, h: 15 }) : undefined,
              exhibition: val['exhibition']
            }
            
            if (val['children'] && val['children'].length > 0) {
              v['children'] = f(val['children'])
            }
            toSessionMenus.push(val)
            _v.push(v)
          });
        }
        //将菜单存入session中
        Session.set(constants.env.app_storage_key + '@menu', toSessionMenus)
        return _v
      }
      if (success) {
        let _data = f(data)
        const loopMenu = (menu, pitem = {}) => {
          menu.forEach(item => {
            if (pitem.path) {
              item.parentPath = pitem.parentPath ? pitem.parentPath.concat(pitem.path) : [pitem.path];
            }
            if (item.children && item.children.length) {
              loopMenu(item.children, item);
            }
          });
        }
        loopMenu(_data);
        yield put({
          type: 'getMenuSuccess',
          payload: _data,
        });
      } else {
        wizNotice.error(msg || '获取菜单失败')
      }
    },

  },

  reducers: {
    getMenuSuccess(state, { payload }) {
      return {
        ...state,
        menu: payload,
        flatMenu: getFlatMenu(payload),
      };
    }
  },
};

export function getFlatMenu(menus) {
  let menu = [];
  menus.forEach(item => {
    if (item.children) {
      menu = menu.concat(getFlatMenu(item.children));
    }
    menu.push(item);
  });
  return menu;
}
